import React from 'react';
import TopicsPage from '../pages/topics/index';

const Topics = ({ userRoles, companyId, companyName, selectedSubMenu }) => {
    return (
        <TopicsPage userRoles={userRoles}  companyId={companyId} companyName={companyName} selectedSubMenu={selectedSubMenu} />
    )
}

export default Topics;